import type { RootState } from 'APP/Store/CreateStore'

export const selectSemanticSearchResults = (state: RootState) => state.semanticSearch.results
export const selectSemanticSearchLoading = (state: RootState) => state.semanticSearch.loading
export const selectSemanticSearchError = (state: RootState) => state.semanticSearch.error
